<template>
	<div class="is-flex flex-wrap is-justify-content-flex-start">
		<div class="is-breadcrumb" v-for="(row, i) in crumbs" :key="i">
			<a @click="Go(row)" v-if="row.fn">{{ row.text }}</a>
			<a :href="row.url" v-else-if="row.url">{{ row.text }}</a>
			<span v-else>{{ row.text }}</span>
		</div>
	</div>
</template>
<script>
	import { ref, computed } from "vue";
	export default {
		props: {
			crumbs: {
				//Array should be an array of objects that take: { url?: string, text: string }
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		emits: ["afterClick"],
		setup(props, context) {
			const Go = (row) => {
				row.fn();
				context.emit("afterClick", row);
			};

			return {
				Go
			};
		}
	};
</script>
<style lang="scss">
	.is-breadcrumb {
		margin-right: 5px;
		&:not(:last-child)::after {
			content: " >";
		}
	}
</style>